import {useEffect, useState} from 'react';
import {formatCallDuration} from '../services/format';

const TICK_MS = 1_000;

export const useElapsed = (since: number | undefined): string | undefined => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (!since) {
            return;
        }
        setNow(Date.now());
        const timer = window.setInterval(() => setNow(Date.now()), TICK_MS);
        return () => window.clearInterval(timer);
    }, [since]);
    return since ? formatCallDuration(now - since) : undefined;
};
